module.exports = __webpack_public_path__ + "static/11-c736e0be7a491d97c9a898f84b61fb15.png";